module.exports = __webpack_public_path__ + "static/media/discoverImg4.1510116d.jpg";